import SliderCarousel from './sliderCarousel/sliderCarousel.component';
export { SliderCarousel };
